import script from "./MyProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProfile.vue?vue&type=script&setup=true&lang=js"

import "./MyProfile.vue?vue&type=style&index=0&id=032b97d6&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032b97d6"]])

export default __exports__